module.exports = __webpack_public_path__ + "img/hk_room_floorplan_06.ca0a434a.png";